import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);

const ROUND_DATE_FORMATS = [
  'MM/DD/YY',
  'M/D/YY',
  'MM/D/YY',
  'M/DD/YY',
  'MM/DD/YYYY',
  'M/D/YYYY',
];

export function parseRoundDate(dateStr) {
  if (dateStr == null || dateStr === '') return null;
  if (typeof dateStr.toDate === 'function') {
    const fromTimestamp = dayjs(dateStr.toDate());
    return fromTimestamp.isValid() ? fromTimestamp : null;
  }
  if (dateStr instanceof Date) {
    const fromDate = dayjs(dateStr);
    return fromDate.isValid() ? fromDate : null;
  }
  const value = String(dateStr).trim();
  if (!value) return null;
  const strict = dayjs(value, ROUND_DATE_FORMATS, true);
  if (strict.isValid()) return strict;
  const loose = dayjs(value, ROUND_DATE_FORMATS);
  if (loose.isValid()) return loose;
  const fallback = dayjs(value);
  return fallback.isValid() ? fallback : null;
}

export function formatRoundDesc(round) {
  if (!round) return '';
  const parsed = parseRoundDate(round.date);
  if (parsed) {
    let desc = parsed.format('ddd') + ' ' + parsed.format('MM/DD');
    if (round.practice) desc += ' (P) ';
    return desc;
  }
  return round.name || round.date || round.id || '';
}

export default dayjs;
